"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fetchJsonLd_1 = require("./fetchJsonLd");
Object.defineProperty(exports, "fetchJsonLd", { enumerable: true, get: function () { return fetchJsonLd_1.default; } });
var parseHydraDocumentation_1 = require("./parseHydraDocumentation");
Object.defineProperty(exports, "parseHydraDocumentation", { enumerable: true, get: function () { return parseHydraDocumentation_1.default; } });
Object.defineProperty(exports, "getDocumentationUrlFromHeaders", { enumerable: true, get: function () { return parseHydraDocumentation_1.getDocumentationUrlFromHeaders; } });
//# sourceMappingURL=index.js.map